import { useState } from 'react';
import { useNavigate } from 'react-router';

import { ActionPrompt } from '../../../components';
import { getStepConfig } from '../../../getStepConfig';
import { usePatientIntakeStatusContext } from '../../../hooks';
import type { BaseStepsBaseProps } from '../BaseSteps.types.ts';
import { MedicareIHIModal } from './MedicareIHIModal.tsx';

interface MedicareIHIBaseStepActionProps extends BaseStepsBaseProps {}

export const MedicareIHIBaseStepAction = ({ onEdit }: MedicareIHIBaseStepActionProps) => {
  const navigate = useNavigate();
  const { baseSteps, isHealthcareProvider } = usePatientIntakeStatusContext();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const step = baseSteps?.MEDICARE_VERIFICATION;

  const handleOnClick = () => {
    if (!isHealthcareProvider && step?.currentStatus.status !== 'COMPLETED') {
      navigate('/medical-info/concession-cards');

      return;
    }

    setIsModalOpen(true);
  };

  const handleOnEdit = () => {
    onEdit();
  };

  const handleModalOnClose = () => {
    setIsModalOpen(false);
  };

  if (!step) {
    return null;
  }

  const stepConfig = getStepConfig('MEDICARE_VERIFICATION');

  const title = stepConfig.title({
    step,
    isHealthcareProvider,
  });

  const description = stepConfig.statuses[step.currentStatus.status].description({
    step,
    isHealthcareProvider,
  });

  return (
    <>
      <ActionPrompt step={step} title={title} description={description} onClick={handleOnClick} onEdit={handleOnEdit} />

      {isModalOpen && <MedicareIHIModal step={step} isOpen={isModalOpen} onClose={handleModalOnClose} />}
    </>
  );
};
